/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { lazy, Suspense, useState } from 'react';
import {
  BrowserRouter,
  useRoutes,
  RouteObject,
  useNavigate,
} from 'react-router-dom';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { getLandingPageRoute } from '@pages/LandingPage';
import { getPlaceholderPageRoute } from '@pages/Placeholder';
import { getVendingMachinePageRoute } from '@pages/VendingMachinePage';
import ScrollToTop from './ScrollToTop';
import { useSMAppNavigator } from './machines/pageContent';
import { useSMmyProfilePage } from './machines/getMyProfile';
import { getRegisterPageRoute } from '@/pages/Register';
import { getSignInPageRoute } from '@/pages/SignIn';
import { getSignUpPageRoute } from '@/pages/SignUp';
import { getOrganisationProfilePageRoute } from '@/pages/OrganisationProfile';
import { getDirectorPageRoute } from '@/pages/Directors/routes';
import { getProfilePageRoute } from '@/pages/Profile';
import { getAdminPageRoute } from '@/pages/Admin';
import { getEmployeePageRoute } from '@/pages/Employee';
import { getSubmittedPageRoute } from '@/pages/SubmittedApplications';
import { getRejectedPageRoute } from '@/pages/RejectedApplications';
import { getApplicationStatusPageRoute } from '@/pages/ApplicationStatus';
import { getApplicationFormPageRoute } from '@/pages/ApplicationForm';
import { getDraftPageRoute } from '@/pages/DraftApplications';
import { getMasterAdminInvitePageRoute } from '@/pages/MasterAdminInvite';
import { getResetPasswordPageRoute } from '@/pages/ResetPassword/routes';
import { getForgotPasswordPageRoute } from '@/pages/ForgotPassword/routes';
import { EventBusModule } from '@vlinder-web/event-bus-module-react';

import { getStatusTimelinePageRoute } from '@/pages/StatusTimeLine';

import { getApplicationDetailPageRoute } from '@/pages/ApplicationDetail';

import { getPaymentPageRoute } from '@/pages/Payment';
import { getMarriageCertificateListPageRoute } from '@/pages/MarriageCertificatesList';
import { getWorkPermitListPageRoute } from '@/pages/WorkPermitList';
import { getPaymentSuccessPageRoute } from '@/pages/PaymentSuccess';
import { getPaymentFailurePageRoute } from '../pages/PaymentFailure';
import { getApprovedPageRoute } from '@/pages/ApprovedApplications';
import { getMissingInfoPageRoute } from '@/pages/MissingInfo';
import { getPendingPaymentPageRoute } from '@/pages/PendingPayments';

import { getNotFoundPageRoute } from '@pages/Notfound';
import { getInviteStatusPageRoute } from '@pages/InviteStatus';
import { getInviteAcceptedPageRoute } from '@pages/InviteAccepted';
import { getInviteExpiredPageRoute } from '@pages/InviteExpired';
import { getInviteRejectedPageRoute } from '@pages/InviteRejected';
import { getCSMECertificateListPageRoute } from '@/pages/CSMECertificateList';
import { getGenericReportPageRoute } from '@/pages/GenericReport';
import SwitchRolesPage from '@/pages/SwitchRoles';
import { ROLES_MODAL_OPEN } from '@/pages/SwitchRoles/container/container.com';
import { getUserListPageRoute } from '@/pages/UsersList';
import { getUserProfilePageRoute } from '@/pages/UserProfile';
import { getPaymentTransactionPageRoute } from '@/pages/PaymentTransactions';
import { getPaymentHistoryPageRoute } from '@/pages/PaymentHistory';
import { Graphql } from '@/common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { vappContainer } from '@/application';
import { AppNavigatorService } from './services';
import { getMasterReportPageRoute } from '@/pages/MasterReport';
import { getCredentialListPageRoute } from '@/pages/CredentialList';
import { getCredentialDetailPageRoute } from '@/pages/CredentialDetail';
import { getAddRolePageRoute } from '@/pages/AddRole';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export const AppNavigator = (): JSX.Element => {
  const { appNavigatorSend, appNavigatorState, appNavigatorMachine } =
    useSMAppNavigator({});
  const { myProfilePageSend } = useSMmyProfilePage({});
  const storageSrv = StorageModule.getInstance();

  console.log(
    'appNavigatorState?.event?.data?.value ',
    appNavigatorState?.event?.data?.value
  );
  if (appNavigatorState?.matches('RENDER_PAGE')) {
    const {
      brandLogo,
      brandLogoLink,
      brandTitle,
      sidebarItems,
      routes,
      orgName,
      orgUrl,
      copyrightStartYear,
      whoami,
      userName,
      userImage,
      dropdownItems,
      footerSection,
    } = { ...(appNavigatorState?.event?.data?.value || {}) };

    const RouterConfig = () => {
      const navigate = useNavigate();

      const [countData, setCountData] = useState({
        draftApp: null,
        pendingPaymentApp: null,
      });

      const updateBadgesByIds = (data: any, updates: any) => {
        return data.map((item: any) => {
          const update = updates.find((update: any) => update.id === item.id);

          if (update) {
            return {
              ...item,
              badgeText: update.badgeText,
              badgeBg: update.badgeBg,
            };
          } else if (item.children) {
            return {
              ...item,
              children: updateBadgesByIds(item.children, updates),
            };
          }

          return item;
        });
      };

      let updates: any[] = [];
      const [notification, setNotification] = useState(sidebarItems);

      const updateNotifiation = async () => {
        console.log('Sidebar #3 updateNotifiation->draft app');
        let gql = Graphql.withBaseUrl(apiConfig.gql.url);
        // const token = getToken();
        const token = loginSrv()?.getToken();
        if (token) {
          gql = gql.withHeaders({
            authentication: token,
          });
        }

        const storageService = StorageModule.getInstance();
        const _localData = storageService.get('userProfile', 'local');
        const _sessionData = storageService.get('userProfile', 'session');
        const userData = _sessionData ?? _localData;
        const whoAmI =
          userData?.currentRole ??
          (userData?.userRoles && Array.isArray(userData?.userRoles)
            ? userData?.userRoles[0]?.name
            : null);
        const client = gql.getClient();
        let updatedSideBarITems: any = [];
        try {
          if (client) {
            const draftStatusValue =
              whoAmI === 'prospective_employee'
                ? ['APPLICANT_DRAFT']
                : ['APPLICATION_INCOMPLETE', 'APPLICANT_DRAFT'];
            const paymentStatusValue =
              whoAmI === 'prospective_employee'
                ? ['READY_TO_PAY']
                : ['READY_TO_PAY', 'WAITING_FOR_WP_FEE'];
            const typeNotIn =
              whoAmI === 'prospective_employee'
                ? ['NEW_WORK_PERMIT', 'RENEW_WORK_PERMIT']
                : [
                    'CSME_VERIFICATION',
                    'NEW_CSME_CERTIFICATE',
                    'RENEW_CSME_CERTIFICATE',
                    'MARRIAGE_EXEMPTION',
                  ];
            const res = await client.query(GET_APPLICATION_COUNT, {
              draftApp: {
                where: [
                  {
                    column: 'status',
                    value: draftStatusValue,
                    op: 'In',
                  },
                ],
              },
              pendingPaymentApp: {
                where: [
                  {
                    column: 'status',
                    op: 'In',
                    value: paymentStatusValue,
                  },
                  {
                    column: 'type',
                    op: 'NotIn',
                    value: typeNotIn,
                  },
                ],
              },
            });
            if (res?.data) {
              console.log(`getApplicationCount`, res?.data);
              if (
                res?.data?.draftApp !== countData?.draftApp ||
                res?.data?.pendingPaymentApp !== countData?.pendingPaymentApp
              ) {
                updates = [
                  {
                    id: 'DraftAppList',
                    badgeText: res?.data?.draftApp,
                    badgeBg: 'danger',
                  },
                  {
                    id: 'PendingPayment',
                    badgeText: res?.data?.pendingPaymentApp,
                    badgeBg: 'danger',
                  },
                ];

                updatedSideBarITems = updateBadgesByIds(props?.items, updates);
                setCountData(res?.data);
                console.log(
                  'Sidebar #4 updateNotifiation totalCount->',
                  updatedSideBarITems
                );
                setNotification(updatedSideBarITems);
              }
            }
          }
        } catch (err: any) {
          console.log(`error in table data`, err);
        }
        console.log(
          'Sidebar #3 updateNotifiation totalCount->',
          updatedSideBarITems
        );
      };
      const _handleDropDownItemClick = (item: any) => {
        const eventBus = EventBusModule?.getInstance()?.getEventBus();

        console.log(`id`, item?.id);
        if (item.id === 'logout') {
          storageSrv.reset('session');
          storageSrv.reset('local');
          navigate(`/`);
        } else if (item?.id === 'switchRole') {
          eventBus.emit(ROLES_MODAL_OPEN, null, {});
        } else if (item?.id === 'myProfile') {
          navigate('/profile/my-profile');
        }
      };
      const props = {
        brandLogo,
        brandLogoLink,
        brandTitle,
        items: sidebarItems,
        routes,
        countData,
        notification,
        updateNotifiation,
        orgName,
        orgUrl,
        copyrightStartYear,
        whoami,
        userName,
        userImage,
        dropdownItems,
        onDropDownItemClick: _handleDropDownItemClick,
        footerSections: footerSection,
      };

      const routess = useRoutes([
        getLandingPageRoute(props),
        getPlaceholderPageRoute(props),
        getVendingMachinePageRoute(props),
        getNotFoundPageRoute(props),
        getRegisterPageRoute(props),
        getInviteStatusPageRoute(props),
        getInviteRejectedPageRoute(props),
        getInviteExpiredPageRoute(props),
        getInviteAcceptedPageRoute(props),
        getSignInPageRoute(props),
        getSignUpPageRoute(props),
        getAddRolePageRoute(props),
        getOrganisationProfilePageRoute(props),
        getAdminPageRoute(props),
        getProfilePageRoute(props),
        getEmployeePageRoute(props),
        getSubmittedPageRoute(props),
        getDirectorPageRoute(props),
        getCredentialListPageRoute(props),
        getRejectedPageRoute(props),
        getApplicationFormPageRoute(props),
        getApplicationStatusPageRoute(props),
        getDraftPageRoute(props),
        getMasterAdminInvitePageRoute(props),
        getResetPasswordPageRoute(props),
        getForgotPasswordPageRoute(props),
        getStatusTimelinePageRoute(props),
        getApplicationDetailPageRoute(props),
        getPaymentPageRoute(props),
        getWorkPermitListPageRoute(props),
        getPaymentSuccessPageRoute(props),
        getPaymentFailurePageRoute(props),
        getApprovedPageRoute(props),
        getMissingInfoPageRoute(props),
        getPendingPaymentPageRoute(props),
        getCSMECertificateListPageRoute(props),
        getMarriageCertificateListPageRoute(props),
        getGenericReportPageRoute(props),
        getUserListPageRoute(props),
        getUserProfilePageRoute(props),
        getMasterReportPageRoute(props),
        getPaymentTransactionPageRoute(props),
        getPaymentHistoryPageRoute(props),
        getCredentialDetailPageRoute(props),
      ]);

      return routess;
    };
    console.log('whoami', whoami);
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div></div>}>
          <RouterConfig />
          <SwitchRolesPage whoami={whoami} />
        </Suspense>
      </BrowserRouter>
    );
  }
  if (appNavigatorState?.matches('GET_PAGE_CONTENT')) {
    return <div />;
  }
  return <></>;
};
